import { render, staticRenderFns } from "./VueTextControl.vue?vue&type=template&id=2410a547&scoped=true&"
import script from "./VueTextControl.vue?vue&type=script&lang=js&"
export * from "./VueTextControl.vue?vue&type=script&lang=js&"
import style0 from "./VueTextControl.vue?vue&type=style&index=0&id=2410a547&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2410a547",
  null
  
)

export default component.exports